<template lang="pug">
  .panel-page
    .panel.mx-auto
      FormErrorAlert(:message="message" v-show="message !== ''" @dismiss="message = ''")
      a.back-button.body-3(@click="prevState()")
        img(src='../assets/img/back_button.svg', alt='back button')
        |  Back
      h1.mt-4 Review User Registration Form
      .body-1 Please review information below before submitting form.
      .body-1.mt-4
        | User request for
        span.h5
          em  {{ agencyName }}
      //- Personal Info
      .review-section-heading
        span.h5 PERSONAL INFORMATION
        a.edit-link(@click="prevState('personal-section')",href="#") Edit
      span.field-name.h6 First Name:
      span.field-value  {{ firstName }}
      br
      span.field-name.h6 Middle Name:
      span.field-value  {{ middleName }}
      br
      span.field-name.h6 Last Name:
      span.field-value  {{ lastName }}
      br
      span.field-name.h6 Primary Email Address:
      span.field-value  {{ primaryEmail }}
      br
      span.field-name.h6 Work Phone Number:
      span.field-value  {{ formattedPhoneNumber }}
      br
      span.field-name.h6 Supervisor's First Name:
      span.field-value  {{ superFirstName }}
      br
      span.field-name.h6 Supervisor's Middle Name:
      span.field-value  {{ superMiddleName }}
      br
      span.field-name.h6 Supervisor's Last Name:
      span.field-value  {{ superLastName }}
      br
      span.field-name.h6 Supervisor's Rank:
      span.field-value  {{ superRank }}
      br
      span.field-name.h6 Supervisor's Email Address:
      span.field-value  {{ superEmail }}
      br
      span.field-name.h6 Supervisor's Phone Number:
      span.field-value  {{ formattedSuperPhoneNumber }}
      br
      //- Account Info
      .review-section-heading
        span.h5 PROFESSIONAL INFORMATION
        a.edit-link(@click="prevState('professional-section')",href="#") Edit
      span.field-name.h6 User State:
      span.field-value  {{ agencyState }}
      br
      span.field-name.h6 User Agency:
      span.field-value  {{ agencyName }}
      br
      span.field-name.h6 Title:
      span.field-value  {{ title }}
      br
      //- Account Info
      .review-section-heading
        span.h5 ACCOUNT INFORMATION
        a.edit-link(@click="prevState('account-section')",href="#")  Edit
      span.field-name.h6 User Name:
      span.field-value  {{ username }}
      br
      span.field-name.h6 Password:
      span.field-value  ********
      br
      span.field-name.h6 User Level:
      span.field-value  {{ fullUserLevel }}
      br
      span.field-name.h6 User Role:
      span.field-value  {{ fullUserRole }}
      br
      span.field-name.h6 Are you a U.S. Immigration and Customs Enforcement (ICE) agent?
      span.field-value  {{ iceAgent ? 'Yes' : 'No' }}

      .mt-3
        button.btn.btn-primary(@click="submitForm") Submit
        button.btn.btn-light.ml-3(@click.prevent="$emit('cancel')") Cancel
</template>

<script>
import axios from '@/lib/axios.js'
import FormErrorAlert from '@/components/FormErrorAlert'
import { loadForm } from '@/lib/formstore'

export default {
  name: 'RegistrationReviewInfo',
  data: function() {
    return {
      message: '',
      registration: '',
      agencyName: '',
      agencyState: '',
      agencyId: '',
      firstName: '',
      middleName: '',
      lastName: '',
      primaryEmail: '',
      confirmEmail: '',
      workPhone: '',
      superFirstName: '',
      superMiddleName: '',
      superLastName: '',
      superRank: '',
      superEmail: '',
      superPhone: '',
      title: '',
      username: '',
      password: '',
      confirmPassword: '',
      userLevel: '',
      userRole: '',
      swornValue: 'swornValue',
      iceAgent: false,
    }
  },
  computed: {
    fullUserRole: function() {
      return this.swornValue === 'sworn'
        ? 'Sworn Personnel'
        : 'Non-Sworn Personnel (Civilian)'
    },
    fullUserLevel: function() {
      return this.userLevel === 'agency_admin'
        ? 'Agency Website User Administrator'
        : 'Basic User'
    },
    formattedPhoneNumber() {
      return this.workPhone.replace(/[^\d]/g, '')
    },
    formattedSuperPhoneNumber() {
      return this.superPhone.replace(/[^\d]/g, '')
    },
  },
  methods: {
    submitForm: function() {
      axios({ auth: false })
        .post('/api/users/register', {
          username: this.username,
          email: this.primaryEmail.toLowerCase(),
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          middleName: this.middleName,
          agencies: [this.agencyId],
          states: [this.agencyState],
          agencyName: this.agencyName,
          userLevel: this.userLevel,
          sworn: this.swornValue === 'sworn',
          workPhone: this.formattedPhoneNumber,
          title: this.title,
          iceAgent: this.iceAgent,
          superFirstName: this.superFirstName,
          superMiddleName: this.superMiddleName,
          superLastName: this.superLastName,
          superRank: this.superRank,
          superEmail: this.superEmail,
          superPhone: this.formattedSuperPhoneNumber,
        })
        .then(() => this.$emit('nextState'))
        .catch(err => (this.message = err.response.data.message || err.message))
    },
    prevState: function(anchor) {
      this.$emit('prevState', anchor)
    },
  },
  mounted: loadForm(
    'registration',
    'agencyName',
    'agencyState',
    'agencyId',
    'firstName',
    'middleName',
    'lastName',
    'primaryEmail',
    'confirmEmail',
    'workPhone',
    'superFirstName',
    'superMiddleName',
    'superLastName',
    'superRank',
    'superEmail',
    'superPhone',
    'title',
    'username',
    'password',
    'confirmPassword',
    'userLevel',
    'userRole',
    'swornValue',
    'iceAgent',
  ),
  components: {
    FormErrorAlert,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/bodies';
$width: 835px;

.review-info-panel {
  background: #ffffff;
  border: 2px solid #e6e6e6;
  padding: 2em 3em;
  width: $width;
}

.back-button {
  img {
    width: 5%;
  }
}

.review-section-heading {
  background-color: #e6e6e6;
  padding: 0.2rem;
  margin-top: 0.7rem;
  margin-top: 0.7rem;
}

.field-name {
  color: #4d4d4d;
}

.field-value {
  @extend .body-1;
}

.edit-link {
  padding-left: 0.8rem;
}
</style>
